export type SetSystemSecurityPayload = {
	autoLogout: boolean;
	autoLogoutDuration: number;
};

export type SnmpTrapConfiguration = {
	trapEnabled: boolean;
	trapAddress: string;
	trapCommunity: string;
	trapOptions: {
		authFailure: boolean;
		networkConnection: boolean;
		otherOption: boolean;
	};
};

export type SnmpV2Options = {
	readCommunity: string;
	writeCommunity: string;
} & SnmpTrapConfiguration;

export type SnmpV3Options = {
	username: string;
	authProtocol: SnmpAuthenticationProtocol;
	authPassword: string;
	privacyProtocol: SnmpPrivacyProtocol;
	privacyPassword: string;
} & SnmpTrapConfiguration;

export enum SnmpType {
	NONE = "none",
	V2 = "v2",
	V3 = "v3"
}

export enum SnmpAuthenticationProtocol {
	NONE = "None",
	MD5 = "MD5",
	SHA = "SHA"
}

export enum SnmpPrivacyProtocol {
	NONE = "None",
	DES = "DES",
	AES = "AES"
}
